import {
    POST,
    GET
} from "../util";
const currencyUrl = "api​/currency/";
const url = {
    list: `${currencyUrl}list`, //
    listEnabled: 'api/currency/listEnabled', //
    currencyExchangeRates: "api/admin/currencyexchange/list/latest"
};
const currencyApi = {
    List: (params = {}) => {
        return GET(url.list, params);
    },
    ListEnabled: () => {
        return GET(url.listEnabled, {}, false);
    },
    getCurrencyExchangeRates: () => {
        return GET(url.currencyExchangeRates);
    }
};
export {
    currencyApi
};